<template>
  <div style="display: flex">
    <div style="border: 1px solid #EBEEF5;width:350px;overflow: auto;">
      <div style="display: flex;align-items: center; align-self: center;height: 50px;padding: 0 20px;background-color: #F5F7FA;">
        <el-checkbox :disabled="isDisabled" :indeterminate="isIndeterminate" v-model="checkAll" style="width: 100px" @change="notSelectCheckAllChange" >全选</el-checkbox>
      </div>
      <div style="height: 400px;overflow: auto">
        <el-checkbox-group :disabled="isDisabled" v-model="moduleNotSelectDataValue" style="padding: 0 20px;" @change="notSelectCheckeditemChange">
          <el-checkbox v-for="data in notSelectDataList" :label="data.id" :key="data.id" style="min-width: 130px">{{data.name}}
            <span v-if="!isDisabled && data.personal" style="color: #4D78FF" @click="updateModules(data.id)">&nbsp;- 编辑</span>
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div style="padding: 0 20px;margin: auto 0px;">
      <div class="module-icon-div" @click="moduleCaretLeft">
        <icon class="el-icon-caret-left"/>
      </div>
      <div class="module-icon-div" @click="moduleCaretRight">
        <icon class="el-icon-caret-right"/>
      </div>
    </div>
    <div style="border: 1px solid #EBEEF5;width:350px;overflow: auto;">
      <div style="display: flex;align-items: center; align-self: center;height: 50px;padding: 0 20px;background-color: #F5F7FA;">
        <el-checkbox :disabled="isDisabled" :indeterminate="isSelectIndeterminate" v-model="selectCheckAll" style="width: 100px" @change="selectedCheckAllChange" >全选  </el-checkbox>
      </div>
      <div style="height: 400px;overflow: auto">
        <el-checkbox-group :disabled="isDisabled" v-model="moduleSelectDataValue" style="padding: 0 20px;" @change="selectCheckeditemChange">
          <el-checkbox v-for="(data, index) in moduleSelectedDataList" :label="data.id" :key="data.id">
            {{data.name}}
            <div v-if="!isDisabled">
             &nbsp; - <icon class="el-icon-bottom" @click="downtempSerial(moduleSelectedDataList, index)"/><icon class="el-icon-top" @click="tempSerial(moduleSelectedDataList, index)"/>
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    moduleDataValue: {
      type: Array,
      default: () => {
        return []
      }
    },
    isDisabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      modulList: [],
      notSelectDataList: [],
      moduleSelectedDataList: [],
      moduleSelectDataList: [],
      moduleNotSelectDataValue: [],
      moduleSelectDataValue: [],
      indicatorGroupDetailVisible: false,
      isIndeterminate: true,
      isSelectIndeterminate: true,
      checkAll: false,
      selectCheckAll: false,
      caretRightModuleList: [],
      tadsimModulesUrl: location.hostname === 'localhost' ? 'https://usp-test.uaes.com' : ''
    }
  },
  computed: {
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        console.log(newVal)
        this.notSelectDataList = newVal
      },
      deep: true,
      immediate: true
    },
    dataList: {
      handler(newVal, oldVal) {
        console.log(newVal)
        this.modulList = newVal
      },
      deep: true,
      immediate: true
    },
    moduleDataValue: {
      handler(newVal, oldVal) {
        console.log('moduleDataValue')
        console.log(newVal)
        console.log(oldVal)
        if (newVal) {
          this.moduleSelectedDataList = []
          const list = this.forNotSelectList(newVal)
          this.moduleSelectDataList = list
          this.moduleCaretRightCopy()
        }
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
  },
  methods: {
    notSelectCheckAllChange(val) {
      let list = []
      if (val) {
        list = this.getNotSelect()
      }
      else {
        this.moduleSelectDataList = []
      }
      this.moduleNotSelectDataValue = list
      this.isIndeterminate = false
    },
    getNotSelect() {
      const notSelect = this.notSelectDataList
      const dataValue = this.moduleNotSelectDataValue
      for (var i = 0; i < notSelect.length; i++) {
        dataValue.push(notSelect[i].id)
      }
      this.moduleSelectDataList = this.moduleSelectDataList.concat(notSelect)
      return dataValue
    },
    moduleCaretRight() {
      let arr = this.notSelectDataList
      const list = this.moduleSelectDataList
      if (!list || list.length === 0) {
        this.$message({
          message: '请选择要移动的数据。',
          type: 'warning'
        })
        return false
      }
      this.moduleSelectedDataList = this.moduleSelectedDataList.concat(list)
      for (const data of list) {
        arr = arr.filter(function(item) {
          return item !== data
        })
      }
      this.getVal(this.moduleSelectedDataList)
      this.notSelectDataList = arr
      this.moduleNotSelectDataValue = []
      this.moduleSelectDataList = []
      this.checkAll = false
    },
    moduleCaretRightCopy() {
      let arr = this.notSelectDataList
      const list = this.moduleSelectDataList
      this.moduleSelectedDataList = this.moduleSelectedDataList.concat(list)
      for (const data of list) {
        arr = arr.filter(function(item) {
          return item !== data
        })
      }
      this.getVal(this.moduleSelectedDataList)
      this.notSelectDataList = arr
      this.moduleNotSelectDataValue = []
      this.moduleSelectDataList = []
      this.checkAll = false
    },
    // 根据已选择的数据去拼接新的数据用于展示在右侧
    forNotSelectList(value) {
      const notSelect = this.dataList
      const dataValue = []
      for (const id of value) {
        for (const item of notSelect) {
          if (id === item.id) {
            dataValue.push(item)
          }
        }
      }
      return dataValue
    },
    notSelectCheckeditemChange(value) {
      const list = this.forNotSelectList(value)
      this.moduleSelectDataList = list
      const checkedCount = value.length
      this.checkAll = checkedCount === this.notSelectDataList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.notSelectDataList.length
    },
    selectCheckAllChange(val) {
      this.moduleSelectDataValue = val ? this.getNotSelect() : []
      this.isSelectIndeterminate = false
    },
    selectCheckeditemChange(value) {
      const list = this.forSelectList(value)
      this.caretRightModuleList = list
      const checkedCount = value.length
      this.selectCheckAll = checkedCount === this.moduleSelectedDataList.length
      this.isSelectIndeterminate = checkedCount > 0 && checkedCount < this.moduleSelectedDataList.length
    },
    // 根据已选择的数据去拼接新的数据用于展示在右侧
    forSelectList(value) {
      const selected = this.moduleSelectedDataList
      const dataValue = []
      for (const id of value) {
        for (const item of selected) {
          if (id === item.id) {
            dataValue.push(item)
          }
        }
      }
      return dataValue
    },
    moduleCaretLeft() {
      let arr = this.moduleSelectedDataList
      const list = this.caretRightModuleList
      if (!list || list.length === 0) {
        this.$message({
          message: '请选择要移动的数据。',
          type: 'warning'
        })
        return false
      }
      this.notSelectDataList = this.notSelectDataList.concat(list)
      for (const data of list) {
        arr = arr.filter(function(item) {
          return item !== data
        })
      }
      this.moduleSelectedDataList = arr
      this.moduleSelectDataValue = []
      this.caretRightModuleList = []
      this.selectCheckAll = false
      this.getVal(this.moduleSelectedDataList)
    },
    selectedCheckAllChange(val) {
      let list = []
      if (val) {
        list = this.getSelect()
      }
      else {
        this.caretRightModuleList = []
      }
      this.moduleSelectDataValue = list
      this.isSelectIndeterminate = false
    },
    getSelect() {
      const notSelect = this.moduleSelectedDataList
      const dataValue = this.moduleSelectDataValue
      for (var i = 0; i < notSelect.length; i++) {
        dataValue.push(notSelect[i].id)
      }
      this.caretRightModuleList = this.caretRightModuleList.concat(notSelect)
      return dataValue
    },
    tempSerial(item, index) { // 向上移动  item是一个数组，index是当前的索引值
      if (index !== 0) {
        item[index] = item.splice(index - 1, 1, item[index])[0]
        this.moduleSelectDataValue[index] = this.moduleSelectDataValue.splice(index - 1, 1, item[index])[0]
      }
      else {
        // item.push(item.shift())
      }
      this.getVal(item)
    },
    downtempSerial(item, index) { // 向下移动  item是一个数组，index是当前的索引值
      if (index !== item.length - 1) {
        item[index] = item.splice(index + 1, 1, item[index])[0]
        this.moduleSelectDataValue[index] = this.moduleSelectDataValue.splice(index + 1, 1, item[index])[0]
      }
      else {
        // item.unshift(item.splice(index, 1)[0])
      }
      this.getVal(item)
    },
    updateModules(id) {
      window.open(`${this.tadsimModulesUrl}/USPSim/modules/${id}/update`)
    },
    getVal(list) {
      const arr = []
      for (const data of list) {
        arr.push(data.id)
      }
      this.$emit('handleChange', arr)
    }
  }
}
</script>

<style scoped>
.module-icon-div{
  width: 40px;
  height: 40px;
  border: 1px solid #DCDFE6;
  background-color: #F5F7FA;
  display: grid;
  justify-content: center;
  align-content: center;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
}
::v-deep .el-checkbox__label {
  min-width: 130px;
  display: inline-flex;
}
</style>
